import React, { FC, useState } from 'react';

// Icons
import 'font-awesome/css/font-awesome.min.css';

interface Features {
    text?: string;
    onPress?: () => void;
    textColor?: string;
    bgColor?: string;
    bgHoverColor?: string;
    rounded?: boolean;
    customClasses?: any;
    fullWidth?: boolean;
}

const FunctionalButton: FC<Features> = (props) => {
    // Defaults
    const textColor = props.textColor !== undefined ? props.textColor : 'text-white';
    const bgColor = props.bgColor !== undefined ? props.bgColor : "bg-primary";
    const bgHoverColor = props.bgHoverColor !== undefined ? props.bgHoverColor : "hover:bg-transparent hover:border-primary hover:text-primary";
    const rounded = props.rounded !== undefined ? 'rounded-full' : null;
    const fullWidth = props.fullWidth !== undefined ? props.fullWidth : true;

    return (
        <button
            onClick={props.onPress}
            type="submit"
            className={fullWidth ? `${bgColor} ${bgHoverColor} ${textColor} font-bold py-2 px-4 ${rounded} border border-transparent font-semibold py-2 px-4 w-full ${props.customClasses}` : `${props.customClasses}`}
        >
            {
                !fullWidth ?
                    <span className={`${bgColor} ${bgHoverColor} ${textColor} font-bold py-2 px-4 ${rounded} border border-transparent font-semibold py-2 px-4 w-full`}>
                        {props.text}
                    </span>
                    :
                    props.text
            }
        </button>
    )
}

export default FunctionalButton;